import * as moment from "moment"
import * as lookup from "../../../../static/lookup.json"
import { getAge } from "../../../components/services/helperFunctions"
import {valueParser, fullNameCoverter, policyTermValue, repeatableJsonArrayMapper} from "../../dataLayerMapper"

export function commonProposalFormApplicationMapper(payload, journeyId, pageId, sectionId, applicationJSON2) {
    // let applicationJSON2 = {}
    let pageIndicator = pageId + "." + sectionId
    applicationJSON2['lifeAssuredDetails'] = {
        ...applicationJSON2['lifeAssuredDetails'],
        "residentStatus": valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "residentialStatus"),
        "personalDetails": {
            "smoking": valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalHealth&LifestyleDetails", "everConsumedTobacco"),
        },
        "preInsuranceDetails": {
            "insuranceDetails": repeatableJsonArrayMapper(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalInsuranceHistory", applicationJSON2)
        },
        "amlAddendum": {
            "eInsurance": {
                "insuranceRepository": valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalInsuranceHistory", "nameOfinsuranceCompanyeia") || '',
                "haveEIA": valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalInsuranceHistory", "eInsuranceDetails") || '',
                "eIANumber": valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalInsuranceHistory", "provideDetailseia") || '',
            }
        }
    }
    applicationJSON2['proposerDetails'] = {
        ...applicationJSON2['proposerDetails'],
        "maritalStatus": valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalProposerDetails", "proposermaritalStatus"), 
    }
    applicationJSON2['nominees'] = repeatableJsonArrayMapper(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalNomineeDetails", applicationJSON2)

    return applicationJSON2
}